<template>
  <div class="header ">
    <div class="flex-center container">
      <img src="../assets/1.png" alt="" :class="{ 'logo-clickable': actputh !== '/' }" @click="goHome">
      <div class="routerlist flex-center ">
        <div :class="item.path == actputh ? 'activecolor' : 'routeritem'" v-for="(item, index) in routers" :key="index"
          @click="skip(item)">
          {{ item.name }}
        </div>
      </div>
      <div class="logintxt flex-center" v-if="!user">
        <span @click="$router.push('/login')">登录</span> <span @click="$router.push('/register')">注册</span>
      </div>
      <div class="logintxt flex-center" v-else>
        <span @click="$router.push('/personcenter')">个人中心</span> <span @click="logout()">退出登录</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      routers: [
        { name: "首页", path: "/" },
        { name: "报价下单", path: "/quoteorder" },
        { name: "关于聚意", path: "/aboutjuyi" },
        { name: "产品展示", path: "/productshow" },
        { name: "视频教程", path: "/videocourse" },
        { name: "印前必看", path: "/yinqianlook" }],
      actputh: ''
    }

  },
  created() {
    this.actputh = this.$route.path;
    this.getUser()
  },
  watch: {
    $route(to) {
      this.actputh = to.path;
    }
  },
  methods: {
    goHome() {
      if (this.actputh === '/') return
      this.$router.push('/')
    },
    skip(item) {
      if (this.actputh == item.path) return
      this.$router.push(item.path)
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  padding: 13px 100px;
  background-color: #333333;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;

  img {
    width: 136px;
    height: 35px;
  }

  .logo-clickable {
    cursor: pointer;
  }

  .routerlist {
    flex: 1;
    padding: 0 140px;

    .routeritem {
      flex: 1;
      text-align: center;
      font-size: 14px;
      color: #FFFFFF;
      cursor: pointer;
      font-weight: bold;

      &:hover {
        color: #FF6700;
      }
    }

    .activecolor {
      flex: 1;
      text-align: center;
      font-size: 14px;
      cursor: pointer;
      font-weight: bold;
      color: #FF6700;
    }
  }

  .logintxt {
    font-size: 14px;
    color: #FFFFFF;

    span {
      padding: 0 10px;

      &:hover {
        color: #FF6700;
      }

      &:last-child {
        position: relative;
        padding-right: 0px;

        &::after {
          content: '';
          position: absolute;
          width: 1px;
          height: 10px;
          background-color: #FFFFFF;
          top: 50%;
          transform: translateY(-50%);
          left: 0;
          z-index: 1;
        }
      }
    }
  }
}
</style>